import Account from '@/api/models/Account'
import Connection from '@/api/models/Connection'
import { State } from '@/store/index'
import { MutationTree } from 'vuex'
import { Status } from '@/api/models/Status'

export enum RootStateMutations {
    setLoading = 'setLoading',
    setConnection = 'setConnection',
    addAccount = 'addAccount',
    updateAccount = 'updateAccount',
    setAccounts = 'setAccounts',
    setCurrentAccountId = 'setCurrentAccountId',
    setSystemStatuses = 'setSystemStatuses',
    setCdekStatuses = 'setCdekStatuses',
    setSystemProductStatuses = 'setSystemProductStatuses',
    setSystemPaymentStatuses = 'setSystemPaymentStatuses',
}

export const mutations: MutationTree<State> = {
    [RootStateMutations.setLoading] (state: State, isLoading: boolean) {
        state.loading = isLoading
    },
    [RootStateMutations.setConnection] (state: State, connection: Connection) {
        state.connection = connection
    },
    [RootStateMutations.addAccount] (state: State, account: Account) {
        state.accounts.push(account)
    },
    [RootStateMutations.setCurrentAccountId] (state: State, accountId: number) {
        state.currentAccountId = accountId
    },
    [RootStateMutations.setAccounts] (state: State, accounts: Array<Account>) {
        state.accounts = accounts
    },
    [RootStateMutations.setSystemStatuses] (state: State, statuses: Array<Status>) {
        state.systemStatuses = statuses
    },
    [RootStateMutations.setCdekStatuses] (state: State, statuses: Array<Status>) {
        state.cdekStatuses = statuses
    },
    [RootStateMutations.setSystemProductStatuses] (state: State, productStatuses: Array<Status>) {
        state.systemProductStatuses = productStatuses
    },
    [RootStateMutations.setSystemPaymentStatuses] (state: State, paymentStatuses: Array<Status>) {
        state.systemPaymentStatuses = paymentStatuses
    }
}
